export default "__VITE_ASSET__CYDpVbDy__"